// frontend/src/components/Layout/Footer.js
import React from 'react';
import styles from '../../styles/layout.module.css';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <p>© 2024 Lahore International School. Powered by <a href="https://devsaura.com" target='_blank' rel='noreferrer'>Devsaura</a></p>
        </footer>
    );
};

export default Footer;